var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.465,
    height: 13.946,
    viewBox: "0 0 14.465 13.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M-56.221,54.97c-.515.371-3.817-1.981-4.449-1.986s-3.972,2.293-4.48,1.913.687-4.276.5-4.885-3.388-3.1-3.187-3.71,4.241-.662,4.756-1.033,1.878-4.211,2.51-4.206,1.934,3.867,2.443,4.246,4.548.5,4.739,1.11-3.046,3.052-3.246,3.657.933,4.521.418,4.892Z",
    transform: "translate(67.851 -41.064)",
    fill: "#f8b84e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fe72ff4a86b517e04593cd43b50226de.svg";
export { ForwardRef as ReactComponent };